export const TWITTER = 2;
export const LINKEDIN = 3;
export const INSTAGRAM = 5;
export const FACEBOOK = 6;

export const SOCIAL_MEDIA_ACCOUNT = 1;
export const SOCIAL_MEDIA_ACCOUNT_PAGE = 2;
